import { apiClient } from './apiClient';

/**
 * Saved payment method from the backend
 */
export interface SavedPaymentMethod {
  id: string;
  brand: string;
  last4: string;
  expiryMonth: number;
  expiryYear: number;
  isDefault: boolean;
}

export const paymentMethodsApi = {
  /**
   * List all saved payment methods for the current user
   */
  async list(): Promise<SavedPaymentMethod[]> {
    const response = await apiClient.get<{
      success: boolean;
      data: SavedPaymentMethod[];
    }>('/api/payment-methods');
    return response.data.data;
  },

  /**
   * Add a new payment method using Stripe payment method ID
   */
  async add(stripePaymentMethodId: string): Promise<SavedPaymentMethod> {
    const response = await apiClient.post<{
      success: boolean;
      data: SavedPaymentMethod;
    }>('/api/payment-methods', { stripePaymentMethodId });
    return response.data.data;
  },

  /**
   * Remove a saved payment method
   */
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/api/payment-methods/${id}`);
  },

  /**
   * Set a payment method as the default
   */
  async setDefault(id: string): Promise<void> {
    await apiClient.patch(`/api/payment-methods/${id}/default`, {});
  },
};
